import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { StratAndTrustPilot } from '../shared';
import { GridListStyle } from '../styles';
import { GridListOption } from '../shared';
import { useSlideData } from '@context/slide-data';

const Style = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    ${props => props.desktop && 'height: 100%;'}
    width: 100%;
    >ul {
        margin-top: 4%;
        height: 100%;
        max-height: 189px;
    }
    >div:nth-of-type(2) {
        margin-top: 10px;
        font-size: ${props => props.theme.mediumFont};
    }
    >div:first-child {
        display: flex;
        ${props => !props.desktop && `
            flex-direction: column;
            align-items: center;
        `}
        justify-content: center;
    }
`;

const TestimonialsGrid = styled(GridListStyle)`
    grid-template-columns: ${props => props.desktop ? '1fr 1fr 1fr' : '1fr'};
    grid-template-rows: 1fr;
`;

export const ClientTestimonials = () => {
    const { t } = useTranslation();
    const { desktop } = useSlideData();
    const slideKey = 'client_testimonials';
    const testimonials = [];

    for (let i = 1; i <= 3; i++) {
        testimonials.push({
            title: t(`${slideKey}.testimonial_${i}.title`),
            text: t(`${slideKey}.testimonial_${i}.text`),
            name: t(`${slideKey}.testimonial_${i}.name`),
        });
    }

    function getGridListOptions(testimonials) {
        return testimonials.map(({ title, text, name }) => (
            <>
                <h4>{title}</h4>
                <span>{text}</span>
                <span className='name'>
                    <em>{name}</em>
                </span>
            </>
        ));
    }

    return (
        <Style desktop={desktop}>
            <StratAndTrustPilot 
                stratLogoDimensions={{ width: '120px' }}
                trustPilotDimensions={{ width: '275px' }}
            />
            <div>
                <strong>{t(`${slideKey}.profile`)}</strong>
                {t(`${slideKey}.blurb`)}
            </div>
            <TestimonialsGrid as='ul' desktop={desktop}>
                {
                    getGridListOptions(testimonials).map((testimonial, index) => (
                        <GridListOption 
                            key={index} 
                            label={testimonials[index].title}
                            option={testimonial} 
                            alignment='flex-start'/>
                    ))
                }
            </TestimonialsGrid>
        </Style>
    );
};

export default ClientTestimonials;
